import { render } from "./AsahiSocialBanner.vue?vue&type=template&id=5863104a&scoped=true&ts=true"
import script from "./AsahiSocialBanner.vue?vue&type=script&lang=ts"
export * from "./AsahiSocialBanner.vue?vue&type=script&lang=ts"

import "./AsahiSocialBanner.vue?vue&type=style&index=0&id=5863104a&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5863104a"]])

export default __exports__